import { Component,ViewChild,ElementRef } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {

  public dropdownSettings: IDropdownSettings;
  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public message: any;
  public countryList:any=[];
  public stateList:any=[];
  public cityList:any=[];
  public genderList:any=[];
  public raceList:any=[];
  public abilityList:any=[];
  public colorList:any=[];
  public planList:any=[];
  public expertList:any=[];
  public allmasterData:any={};
  public loginDetail:any =[];
  public CurrentDetail:any=[];
  public achivementList:any=[];
  public certificateList:any=[];
  public showViews:boolean = false;
  public ssd:any=1;
  public colorCode:any='#808080';
  public otherSelection:any='';
  public otherSelection1:any='';

  public bankDetail:any=[];
  public expertSelected:any=[];
  public expertname:any='';
  public ReasonList:any=[];

  ReviewData = new FormGroup({
    comment:new FormControl('',Validators.compose([
      Validators.required]))  , 
    description:  new FormControl('') 
  })
  get f() { return this.ReviewData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) { 
    window.scroll(0,0);
    this.getReasons();
    this.loginDetail = getLocalJSON('grw_login');
    this.allmasterData = getLocalJSON('grw_materData');
    this.colorList=this.allmasterData.primary_pillars;  
    this.genderList=this.allmasterData.genders;  
    this.abilityList=this.allmasterData.ability;  
    this.raceList=this.allmasterData.race;  
    this.planList=this.allmasterData.subscription;  
    this.allmasterData.expertise.filter((el:any)=>{
      el.chcecked= false;
    })

    if(this.loginDetail.user_role_type ==3){
      this.expertList = this.allmasterData.expertise; 
    } else {
      var self=this;
      this.allmasterData.expertise.filter((el:any)=>{
        if(el.isOrganization == true ) {
          self.expertList.push(el);
        }
      })
    }
    this.getCountry();
    this.getProfile();
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      itemsShowLimit: 5, 
      allowSearchFilter: false ,
      enableCheckAll: false,  
    };
  }


  getProfile(){
    const url = "/profile"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this,kk:any=[];
     
        localStorage.setItem('grw_logincurrency', response.data.userCurrency);
        localStorage.setItem('grw_currencySymbol',response.data.userCurrencySymbol);

         if(response.data.userCurrency !='' && response.data.stripe_account_verify==true && response.data.subscription_added==false){
          this.service.getConversionRate(response.data.userCurrency,2);
        }
        if(response.data.location_country!= '' && response.data.location_country !=null){
          this.getState(response.data.location_country,2);
        }
        if(response.data.achievement !=''){
          var jk:any= response.data.achievement.split(',');
          jk.filter((el:any)=>{
            self.achivementList.push (el);
          })
        }
       if(response.data.certifications !=''){
        var jk:any= response.data.certifications.split(',');
        jk.filter((el:any)=>{
          self.certificateList.push (el);
        })
       }
          if(response.data.other_user_expertises.length !=0){ 
            self.expertname=response.data.other_user_expertises[0].content;    
            self.otherSelection= response.data.expertise_other =response.data.other_user_expertises[0].content;
          }
          this.expertList.filter((el:any)=>{
              el.chcecked = false;
              response.data.user_expertise.filter((ell:any)=>{
                  if(ell._id ==el._id){
                    el.chcecked= true;
                    kk.push(el);
                    if(!el.childContent){
                      if(self.expertname==''){
                        self.expertname=el.name
                      } else {
                        self.expertname=el.name + ' '+self.expertname;
                      }
                    }              
                  } 
                  if(el.childContent == true && el.chcecked == true){
                    self.otherSelection = el._id;
                    if(response.data.other_user_expertises.length != 0 ){
                      response.data.expertise_other =response.data.other_user_expertises[0].content;
                    }
                  }
                })
          });  

        this.colorList.filter((ell:any)=>{
          if(ell._id == response.data.primary_pillar){
            self.colorCode = ell.color;
          }
        })
        var mm:any = document.getElementById("tab12");
        mm.style["background-color"] = self.colorCode;
        var mm:any = document.getElementById("tab45");
        mm.style["background-color"] = self.colorCode;
        this.CurrentDetail =  response.data;
        this.imgURL = response.data.profile_image;
        this.expertSelected = kk;
        localStorage.setItem('grw_login',<any> JSON.stringify(response.data || {}));
        this.service.setSubject(response.data);
        this.loginDetail = response.data;
        this.showViews=true;
        window.scroll(0,0);
      }
    }), (error) => { this.loading =false; });

  }


  getCountry(){
    const url = "/country"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.countryList = response.data;
        if(this.loginDetail.bank_account_added ==true){
          this.getBankDetail(); 
        }
      }
    }), (error) => { this.loading =false; });
  }

  getState(event:any,type:any){
    var mm :any='';
    if(type==1){
      mm= event.target.value;
    } else {
      mm= event;
    }
    const url = "/state?country="+mm ; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.stateList = response.data;
        if(type==2){
          this.getCity(this.CurrentDetail.location_state,2)
        }
      }
    }), (error) => { this.loading =false; });
  }


  getCity(event:any,type:any){
    var mm :any='';
    if(type==1){
      mm= event.target.value;
    } else {
      mm= event;
    }
    const url = "/city?state=" +mm; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.cityList = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  redirectCheck(){
    if(this.loginDetail.profile_complete ==true){
      if(this.loginDetail.stripe_account_verify==true){
        if(this.loginDetail.subscription_added==true){
          this.router.navigate(['/create-post']);
        } else {
          this.service.dangerAlert('Please complete your Subscription detail');
          this.router.navigate(['/edit-profile']);
        }
      } else {
        $("#passlink111").trigger("click");
      }
    } else {
      this.service.dangerAlert('Please complete your profile first');
      this.router.navigate(['/edit-profile']);
    }
  }

  onFilterChange(event: any, type: any) {
    if (type == 1) {
    } else if (type == 2) {
    } else if (type == 3) {
    } else if (type == 4) {
    } else {
    }
    console.log(event);
  }

  changeSelection() {
    var subcatText: any='';
    if (this.expertSelected.length != 0) {
      this.expertSelected.filter(function (el: any) {
        if (subcatText) {
          subcatText = el._id + " , " + subcatText;
        } else {
          subcatText = el._id;
        }
      });
    }
  }

  getBankDetail(){
    const url = "/get-bank-account"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {      
        response.data[0].account_number = 'XXXXXXXX'+response.data[0].last4
        this.countryList.filter((el:any)=>{
            if(el.code == response.data[0].country){
              response.data[0].country_name =el.name;
            }
        })
        this.bankDetail = response.data[0];
        this.showViews=false;
      }
    }), (error) => { this.loading =false; });
  }

  delete(){
    if(this.loginDetail.is_collaborator){
      $('#closebtn1').trigger('click');
      this.service.dangerAlert('Please Cancel your subscription first');
      this.router.navigate(['/partners']);
    } else{
      this.submitted=true;
      if(this.ReviewData.valid){
        this.loading=true;
        var url="/delete-account";
        if(this.otherSelection1==''){
          this.ReviewData.controls["description"].setValue('');
        }
        var detail:any={
          "reason_id":this.ReviewData.value.comment,
          "reason":this.ReviewData.value.description
        }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) {
            this.submitted=false;
            this.ReviewData.reset();
            $('#closebtn1').trigger('click');
            this.loading=false;
            this.service.logOut();
            this.router.navigate(['/']);
          } else {
            this.loading=false;
          }
        }));
      }
    }
  }

  getReasons(){
    const url = "/reason-list"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {     
        this.ReasonList = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  getchek(event:any){
    var self=this;
    self.otherSelection1='';
    this.ReasonList.filter((el:any)=>{
      if(el._id ==event.target.id){
        if(el.childContent){
          self.otherSelection1=el._id;
          self.ReviewData.controls["description"].setValidators([Validators.required,Validators.maxLength(140)]);
          self.ReviewData.controls["description"].updateValueAndValidity();
        }
      }
    })
  }


  callBankLink(){
    this.service.GetApi('/link-account').subscribe(((response:any)=>{
      if(response.success ==1){
        window.open(response.data.data.url, '_blank');
      }
    }))
  }



}
